
import React, { FunctionComponent, FormEvent, useState, useEffect, createRef, } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Visibility, VisibilityOff } from '@mui/icons-material';
import {
  Button,
  Grid,
  TextField,
  InputAdornment,
  IconButton,
  Divider,
} from '@mui/material';

import { RootState, AppDispatch, } from '../../store/store';
import { onboardUser, } from './sign-up';
import AuthLayout from '../../layouts/AuthLayout/AuthLayout';
import { useTranslation,  } from 'react-i18next';
import { LoadingButton } from '@mui/lab';
import { push } from '@lagunovsky/redux-react-router'

import './SignUp.css';
import useTitle from '../../helpers/use-title';

import useValidator from '../../helpers/hooks/use-validator';
import PasswordPolicy from '../../components/PasswordPolicy/PasswordPolicy';
import { useParams } from 'react-router-dom';
import { feedback } from '../../components/Feedback/feedback';
import {redirectBack} from "../../store/middlewares/redirect";

const SignUp: FunctionComponent = () =>  {

  const { t } = useTranslation( [ 'signUp' ] );

  const loading = useSelector( ( state: RootState ) => state.pages.signUp.loading );
  const dispatch = useDispatch<AppDispatch>();

  useTitle( t( 'sign-up' ) );

  // const { token = '' } = useParams<{ token: string }>();
  const searchParams = new URLSearchParams( document.location.search );
  const token = searchParams.get( 'token' ) as string;

  const givenNameRef = createRef<HTMLInputElement>();
  const familyNameRef = createRef<HTMLInputElement>();
  const passwordRef = createRef<HTMLInputElement>();
  const repeatPasswordRef = createRef<HTMLInputElement>();

  useValidator( [ givenNameRef, familyNameRef ] )
    .required()
    .noEmpty()
    .noNumbersAndSpecialCharacters()
    .minLength();

    useValidator( [ passwordRef, ] )
    .required()
    .passwordPolicy();

  const onSubmit = ( event: FormEvent ) => {

    event.preventDefault();

    if (passwordRef.current?.value !== repeatPasswordRef.current?.value) {
      dispatch(feedback({ message: t('noMatchedPasswords') }))
      return;
    }

    const target = event.target as HTMLFormElement;
    const data = Object.fromEntries(new FormData(target));
    dispatch( onboardUser( {
      firstname: ( data.given_name as string ).trim(),
      lastname: ( data.family_name as string ).trim(),
      password: data.password as string,
      token: token,
    } ) )
  }

  useEffect(() => {
    if (!token) {
      dispatch(redirectBack());
      return;
    }
  }, [] );

  const [ password, setPassword ] = useState(false);
  const [ repeatPassword, setRepeatPassword ] = useState(false);

  const onPassword = () => setPassword( !password );
  const onRepeatPassword = () => setRepeatPassword( !repeatPassword );

  return (
    <div className="page page-sign-up">
      <AuthLayout header={ true } large={ true }>
          <form onSubmit={ onSubmit }>
            <h2>{ t( 'header' ) }</h2>
            { t( 'lead' )}
            <p>
            { t('descriptionUserAccountV2' ) }
            </p>
            {/* <p>
            { tM('description-submit' ) }
            </p> */}
            <p>
            { t( 'descriptionLogin' ) }
            </p>
            <Grid container spacing={4} sx={{ marginTop: '0', paddingBottom: '16px'}}>
              <Grid item xs={12} sm={6}>
                <TextField
                  autoComplete=""
                  disabled={ loading !== 'idle' }
                  label={ t( 'givenName' ) }
                  helperText=""
                  name="given_name"
                  inputRef={ givenNameRef }
                  variant='standard'
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  autoComplete=""
                  disabled={ loading !== 'idle' }
                  type="text"
                  label={ t( 'familyName' ) }
                  name="family_name"
                  inputRef={ familyNameRef }
                  variant='standard'
                  fullWidth
                />
              </Grid>

          </Grid>

            <p>
              { t('passwordLead' ) }
            </p>

            <PasswordPolicy></PasswordPolicy>

            <Grid container spacing={4}>
              <Grid item xs={12} sm={6}>
                <TextField
                  autoComplete="password"
                  disabled={ loading !== 'idle' }
                  type={ password ? "text" : "password" }
                  label={ t( 'password' ) }
                  name="password"
                  inputRef={ passwordRef }
                  variant='standard'
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          title={ password ? t( 'show-password' ) : t( 'hide-password' ) }
                          onClick={ onPassword }
                        >
                          { password ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  autoComplete="off"
                  disabled={ loading !== 'idle' }
                  type={ repeatPassword? "text" : "password" }
                  label={ t( 'repeatPassword' ) }
                  name="repeatPassword"
                  inputRef={ repeatPasswordRef }
                  variant='standard'
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          title={ repeatPassword ? t( 'show-password' ) : t( 'hide-password' ) }
                          onClick={ onRepeatPassword }
                        >
                          { repeatPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} sx={{ mt: 5 }}>
                  <LoadingButton
                    loading={ loading ==='pending' }
                    variant='contained'
                    type="submit"
                    fullWidth
                  >
                  { t( 'signup' ) }
                  </LoadingButton>
              </Grid>
            </Grid>
          </form>
      </AuthLayout>
    </div>
  );
}

export default SignUp;
